/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DateUnit {
  Ticks = 'Ticks',
  Month = 'Month'
}
